import {IStockRequestErrorResponse} from './_models'

export const extractErrorMessage = (err: unknown): string | null => {
  const data = (err as {response?: {data?: IStockRequestErrorResponse}})?.response?.data
  const message = typeof data?.message === 'string' ? data.message.trim() : ''
  return message || null
}

export const extractItemErrors = (err: unknown): Record<number, string> => {
  const data = (err as {response?: {data?: IStockRequestErrorResponse}})?.response?.data
  const out: Record<number, string> = {}
  const errors = data?.error
  if (!errors || typeof errors !== 'object') return out
  Object.entries(errors).forEach(([field, msg]) => {
    const match = /^items\.(\d+)\.(quantity|product_supplier_id)$/.exec(field)
    if (!match || typeof msg !== 'string') return
    const index = Number(match[1])
    if (match[2] === 'quantity' || out[index] === undefined) out[index] = msg
  })
  return out
}
